/**
 * Модуль «Тариф и оплата»: работает напрямую с сервисом биллинга (VUE_APP_BILLING_API_URL).
 * Связь с приложением — только через ./host.js.
 */
export {billingEnabled} from "./config";

export const billingRoutes = [
    {
        path: '/billing',
        name: 'billing',
        meta: {title: 'Тариф и оплата'},
        component: () => import('./views/BillingOverview.vue'),
    },
    {
        path: '/billing/plans',
        name: 'billing-plans',
        meta: {title: 'Тарифы', active: 'billing'},
        component: () => import('./views/BillingPlans.vue'),
    },
    {
        path: '/billing/checkout',
        name: 'billing-checkout',
        meta: {title: 'Оформление подписки', active: 'billing'},
        component: () => import('./views/BillingCheckout.vue'),
    },
    {
        path: '/billing/invoices',
        name: 'billing-invoices',
        meta: {title: 'Счета и документы', active: 'billing'},
        component: () => import('./views/BillingInvoices.vue'),
    },
    {
        path: '/billing/invoices/:id',
        name: 'billing-invoice',
        meta: {title: 'Счёт', active: 'billing'},
        component: () => import('./views/BillingInvoice.vue'),
    },
    {
        // Адрес возврата после оплаты в ЮKassa (YOOKASSA_RETURN_URL в биллинге)
        path: '/billing/return',
        name: 'billing-return',
        meta: {title: 'Оплата', active: 'billing'},
        component: () => import('./views/BillingReturn.vue'),
    },
]
